import React from 'react';
import classNames from 'classnames';
import { ReactSVG } from 'react-svg';
import zoomOutIcon from '../images/zoomOut.svg';
import zoomInIcon from '../images/zoomIn.svg';
import { MIN_SCALE } from '../hooks/usePdfViewport';
interface ZoomSelectProps {
    scale: number;
    onZoomIn: () => void;
    onZoomOut: () => void;
}

export const ZoomSelect: React.FC<ZoomSelectProps> = (props) => {
    const { scale, onZoomIn, onZoomOut } = props;
    const safeScale = Number(scale);
    const percentText = Number.isFinite(safeScale) ? `${Math.round(safeScale * 100)}%` : '--%';

    return (
        <div className="toolbar-zoom-content umu-pdf-mobile-hide">
            <ReactSVG
                src={zoomOutIcon}
                className={classNames('toolbar-icon-zoom', {
                    'toolbar-icon-zoom-disabled': !Number.isFinite(safeScale) || safeScale <= MIN_SCALE,
                })}
                onClick={onZoomOut}
            />
            <span className="umu-pdf-zoom-text">{percentText}</span>
            <ReactSVG src={zoomInIcon} className="toolbar-icon-zoom" onClick={onZoomIn} />
        </div>
    );
};
